import type { SelectHTMLAttributes } from 'react';
import { cn } from '../../../helpers/commonUtils';
import styles from './DropDown.module.css';

export type DropDownProps = SelectHTMLAttributes<HTMLSelectElement>;

export function DropDown({ className, children, ...props }: DropDownProps) {
    return (
        <select className={cn(styles.select, className)} {...props}>
            {children}
        </select>
    );
}
